import axios from "axios";
import * as crypto from "crypto-js";
import ResponseAlerts from "../functions/ResponseAlerts";

class UserService {
	static async listUsersPaginated(page, searchText, orderBy) {
		try {
			return await axios.get(
				`identity-service/access-management/users/paginated?page=${page}&limit=8&searchBy=${searchText}&orderBy=${orderBy.collumnTitle}&orderDirection=${orderBy.orderDirection}`,
			);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar usuários",
			});
			return error.response;
		}
	}

	static async listUsersStatus(userIds) {
		try {
			const { data } = await axios.post(`/sse/users/status`, { userIds });
			return data?.status;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar status de usuários",
			});
			return error.response;
		}
	}

	static async listUserSessions(userExternalId) {
		try {
			const { data } = await axios.get(`/sse/users/${userExternalId}/connections`);
			return data?.connections;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao listar sessões ativas",
			});
			return error.response;
		}
	}

	static async revokeUserSessions(userExternalId, clientId) {
		try {
			const { data } = await axios.put(`/sse/users/${userExternalId}/revoke`, { clientId });
			return data;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao revogar sessão ativas do usuário",
			});
			return error.response;
		}
	}

	static async listUsers() {
		return await axios
			.get("identity-service/access-management/users")
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response?.data?.message ?? "Erro ao listar usuários",
				});
				return error.response;
			});
	}

	static async login(email, password) {
		return await axios
			.post(
				"login",
				JSON.stringify({
					email: email,
					senha: password//crypto.SHA256(password).toString(),
				}),
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => {
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response?.data?.message ?? "Erro ao tentar realizar login",
				});
				return error.response;
			});
	}

	static async sendEmailResetPassword(email) {
		return await axios
			.post(
				"login/recover-password",
				JSON.stringify({
					email: email,
				}),
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Email de redefinição de senha enviado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response?.data?.message ?? "Erro ao enviar email para redefinição de senha",
				});
				return error.response;
			});
	}

	static async getUser(id) {
		try {
			return await axios.get(`identity-service/access-management/users/${id}`);
		} catch (error) {
			console.error(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao obter usuário",
			});
			return error.response;
		}
	}

	static async defineNewPassword(userId, token, newPassword) {
		return await axios
			.post(
				"login/reset-password/" + userId + "/" + token,
				JSON.stringify({
					newPassword,
				}),
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Senha redefinida com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response?.data?.message ?? "Erro ao definir nova senha",
				});
				return error.response;
			});
	}

	static async updateUser(id, payload) {
		return await axios
			.put("identity-service/access-management/users/" + id, payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Usuário atualizado com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: error.response?.data?.message ?? "Erro ao atualizar usuário",
				});
				return error.response;
			});
	}

	static async changePassword(id, payload) {
		return await axios
			.put("identity-service/auth/password", payload)
			.then((response) => {
				ResponseAlerts({
					response: response,
					successMessage: "Senha atualizada com sucesso",
				});
				return response;
			})
			.catch((error) => {
				console.log(error);
				ResponseAlerts({
					response: error.response,
					errorMessage: "Erro ao atualizar senha",
				});
				return error.response;
			});
	}

	static async validate2FA(token) {
		try {
			const response = await axios.post(
				"login/validate-2fa",
				JSON.stringify({
					token,
				}),
				{
					headers: {
						"Content-Type": "application/json",
					},
				},
			);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao tentar validar segundo fator",
			});
			return false;
		}
	}

	static async generate2FA() {
		try {
			const response = await axios.post("identity-service/access-management/users/2FA/generate");
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao tentar gerar 2fa qrcode",
			});
			return false;
		}
	}

	static async activate2FA(token) {
		try {
			const response = await axios.post("identity-service/access-management/users/2FA/activate", JSON.stringify({
				token,
			}));
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao tentar ativar 2fa",
			});
			return false;
		}
	}

	static async inactivate2FA(password) {
		try {
			const response = await axios.post("identity-service/access-management/users/2FA/inactivate", JSON.stringify({ password }));
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: "Erro ao tentar inativar 2fa",
			});
			return false;
		}
	}

	static async getAccessibleOrganizations(search, page = 1, itemsPerPage = 8, controller) {
		try {
			return await axios.get(`identity-service/access-management/users/accessible/organizations?search=${search}&page=${page}&itemsPerPage=${itemsPerPage}`, controller ? {
				signal: controller.signal,
			} : null);
		} catch (error) {
			if (error.code === "ERR_CANCELED") return;
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar obter organizações acessíveis",
			});
			return false;
		}
	}

	static async getLastAccessibleOrganizations() {
		try {
			return await axios.get("identity-service/access-management/users/last-accessible/organizations");
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar obter as últimas organizações acessíveis",
			});
			return false;
		}
	}

	static async getAccessibleUnits(token) { }

	static async selectOrganization(organizationId) {
		try {
			return await axios.post(`identity-service/auth/select/organization/${organizationId}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar selecionar a organização",
			});
			return false;
		}
	}

	static async selectRole(roleId) {
		try {
			return await axios.post(`identity-service/auth/assume/${roleId}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar assumir o perfil",
			});
			return false;
		}
	}

	static async updateUrlPreference(urlPreference) {
		try {
			return await axios.put(`identity-service/auth/url-preference/${encodeURIComponent(urlPreference)}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar atualizar preferência de tela inicial",
			});
			return false;
		}
	}

	static async updateTheme(theme) {
		try {
			return await axios.put(`identity-service/auth/theme/${theme}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar atualizar preferência tema",
			});
			return false;
		}
	}

	static async getUserData() {
		try {
			return await axios.get(`identity-service/auth/user-data`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar obter os dados do usuário",
			});
			return false;
		}
	}

	static async getRecoveryPasswordData(userId, token) {
		try {
			return await axios.get(`identity-service/auth/recovery-password-data?userId=${userId}&token=${token}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar obter os dados da recuperação de senha",
			});
			return false;
		}
	}

	static async selectUnit(unitId) {
		try {
			return await axios.post(`identity-service/auth/select/unit/${unitId}`);
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar selecionar a unidade",
			});
			return false;
		}
	}

	static async invite(payload) {
		try {
			const response = await axios.post(`identity-service/identity/persons/invite`, payload);
			ResponseAlerts({
				response: response,
				successMessage: "Convite enviado com sucesso!",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar enviar um novo convite",
			});
			return false;
		}
	}

	static async invitations() {
		try {
			const response = await axios.get(`identity-service/identity/persons/invitations/pendings`);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar obter os convites",
			});
			return false;
		}
	}

	static async invitation(id) {
		try {
			const response = await axios.get(`identity-service/identity/persons/invitation/${id}`);
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar obter o convite",
			});
			return false;
		}
	}

	static async acceptInvitation(id) {
		try {
			const response = await axios.post(`identity-service/identity/persons/accept-invitation/${id}`);
			ResponseAlerts({
				response: response,
				successMessage: "Convite aceito com sucesso!",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar aceitar o convite",
			});
			return false;
		}
	}

	static async denyInvitation(id) {
		try {
			const response = await axios.put(`identity-service/identity/persons/deny-invitation/${id}`);
			ResponseAlerts({
				response: response,
				successMessage: "Convite recusado com sucesso!",
			});
			return response;
		} catch (error) {
			console.log(error);
			ResponseAlerts({
				response: error.response,
				errorMessage: error.response?.data?.message ?? "Erro ao tentar negar o convite",
			});
			return false;
		}
	}
}

export default UserService;
